import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Map } from '@vis.gl/react-google-maps';
import GoogleMapsAdvancedMarker from './GoogleMapsAdvancedMarker';
import { setAdvancedMarkerIsOpen, setAdvancedMarkerId } from '../../Actions/ResellerMapList.action';

export default function GoogleMap ({ defaultZoomSize, dealers, lat, lng }) {
    const dispatch = useDispatch();
    const googleMapState = useSelector((state) => state.resellermaplist);

    const onToggleOpen = (markerId) => {
        dispatch(setAdvancedMarkerIsOpen(!googleMapState.advancedMarkerIsOpen));
        dispatch(setAdvancedMarkerId(markerId));
    };

    return (
        <div id='google-map'>
            <Map
            mapId={'brenderup-dealers'}
            style={{ width: '100%', height: '500px' }}
            defaultZoom={defaultZoomSize}
            gestureHandling={'greedy'}
            defaultCenter={{ lat: parseFloat(lat), lng: parseFloat(lng) }}>
            {dealers.items.length > 0 && dealers.items.map((dealer, index) => (
                <GoogleMapsAdvancedMarker 
                    key={`MAP_${index}`} 
                    markerId={index} 
                    dealer={dealer}
                    onToggleOpen={onToggleOpen} 
                    advancedMarkerIsOpen={googleMapState.advancedMarkerIsOpen} 
                    advancedMarkerId={googleMapState.advancedMarkerId}
                />
            ))}
            </Map>
        </div>
    );
};